import {
    FEVER_API_ENDPOINT,
    FEVER_LOGIN_API_ENDPOINT,
    IMG_PROXY_PATH,
    THIRD_PARTY_AUTH_ENDPOINT,
    ZINES_API_ENDPOINT
} from 'config/envVariable';
import { getPromoInfoApi } from 'api/client';
import { createCSP } from 'utils/createElement';

const clientFlowRegex = /^\/promotions\/([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12})\/\d+\/(join|result|form|lottery|prize\/[0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12}\/[0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12})+/;

const FEVER_CDN_DOMAIN = [
    'https://utility.fevercdn.com',
    'https://widget.fevercdn.com',
    'https://assets.fevercdn.com'
];

const DEFAULT_SCRIPT_SRC = [
    `'self'`,
    `'unsafe-eval'`,
    'https://www.googleadservices.com', // GTM
    'https://www.google.com', // GTM
    'https://googleads.g.doubleclick.net', // GTM
    'https://googletagmanager.com', // GTM
    'https://tagmanager.google.com', // GTM
    'https://*.googletagmanager.com', // GA4
    'https://cse.google.com', // Google Custom Search Engine (CSE)
    'https://connect.facebook.net', // Facebook 追蹤碼
    'https://d.line-scdn.net', // Line 追蹤碼
    ...FEVER_CDN_DOMAIN
].join(' ');

const DEFAULT_STYLE_SRC = [
    `'self'`,
    `'unsafe-inline'`,
    'https://cdnjs.cloudflare.com/', // slick-carousel lib
    'https://googletagmanager.com', // GTM
    'https://tagmanager.google.com', // GTM
    'https://fonts.googleapis.com', // GTM
    'https://*.googletagmanager.com', // GTM
    'https://www.google.com', // Google Custom Search Engine (CSE)
    ...FEVER_CDN_DOMAIN
].join(' ');

const DEFAULT_CONNECT_SRC = [
    `'self'`,
    'data:',
    'https://*.google-analytics.com', // GA4
    'https://*.analytics.google.com', // GA4
    'https://*.googletagmanager.com', // GA4
    'www.googletagmanager.com', // GTM
    'https://analytics.google.com', // GA4
    'https://www.google.com.tw', // GA4
    'https://identitytoolkit.googleapis.com', // Firebase
    'https://securetoken.googleapis.com', // Firebase
    'https://o512271.ingest.sentry.io', //Sentry
    FEVER_API_ENDPOINT,
    ZINES_API_ENDPOINT,
    FEVER_LOGIN_API_ENDPOINT,
    IMG_PROXY_PATH,
    THIRD_PARTY_AUTH_ENDPOINT,
    ...FEVER_CDN_DOMAIN
].join(' ');

export default async function generateCSP() {
    const pathName = window.location.pathname;
    const match = pathName.match(clientFlowRegex);

    if (match && match[1]) {
        const promoUuid = match[1];

        try {
            const {
                promotion: {
                    sponsorSetting: { cspSrcDomains, enableCSP: sponsorEnableCSP }
                }
            } = await getPromoInfoApi({ promoUUID: promoUuid });

            if (Boolean(sponsorEnableCSP)) {
                // 產生 Nonce
                const nonce = generateNonce();
                window.nonceForCSP = nonce;
                const ORIGIN_SCRIPT_SRC = `script-src 'nonce-${nonce}' ${DEFAULT_SCRIPT_SRC} ${cspSrcDomains};`;
                const ORIGIN_STYLE_SRC = `style-src ${DEFAULT_STYLE_SRC} ${cspSrcDomains};`;
                const ORIGIN_CONNECT_SRC = `connect-src ${DEFAULT_CONNECT_SRC} ${cspSrcDomains};`;
                const ORIGIN_WORKER_SRC = `worker-src 'self' blob:;`;
                const ORIGIN_OBJECT_SRC = `object-src none;`;
                const ORIGIN_BASE_URI = `base-uri none;`;
                const [SCRIPT_SRC, STYLE_SRC, CONNECT_SRC, WORKER_SRC, BASE_URI, OBJECT_SRC] = [
                    ORIGIN_SCRIPT_SRC,
                    ORIGIN_STYLE_SRC,
                    ORIGIN_CONNECT_SRC,
                    ORIGIN_WORKER_SRC,
                    ORIGIN_BASE_URI,
                    ORIGIN_OBJECT_SRC
                ].map(config => filterSameDomain(config));
                const cspConfig = `${SCRIPT_SRC} ${STYLE_SRC} ${WORKER_SRC} ${CONNECT_SRC} ${OBJECT_SRC} ${BASE_URI}`;

                createCSP(cspConfig);
                return nonce;
            }
        } catch (err) {
            window.location.href = window.location.origin + '/notfound';
        }
    }
}

/**
 *  產生 Nonce
 */
const generateNonce = () => {
    if (typeof window?.crypto?.getRandomValues === 'function') {
        // Method One：crypto.getRandomValues
        const array = new Uint32Array(2);
        window.crypto.getRandomValues(array);
        return array[0].toString(36) + array[0].toString(36);
    } else if (typeof window?.btoa === 'function') {
        // Method Two：Base64
        return window?.btoa(Date.now().toString(36) + Math.random().toString(36).substring(2));
    } else {
        // Method Three：Radom and Date mixed to base36 string
        return Math.random().toString(36).substring(2) + Date.now().toString(36);
    }
};

/**
 *  過濾相同 Domain
 */
const filterSameDomain = (str = '') => {
    const parts = str.split(' ');
    const uniqueParts = [...new Set(parts)];
    return uniqueParts.join(' ');
};

export const isClientFlow = (pathName = '') => {
    return Boolean(pathName.match(clientFlowRegex));
};
